import NavigationItem from "./NavigationItem";
import NavigationItemNext from "./NavigationItemNext";
import NavigationItemPrevious from "./NavigationItemPrevious";

export default function Navigation({ page, totalPages, goToPage }) {
  const maxPageToShow = 5;
  const bufferPages = 3;
  totalPages = parseInt(totalPages); // Ensure totalPages is an integer
  page = parseInt(page); // Ensure page is an integer

  if (totalPages <= 1) {
    return null;
  }

  // Calculate the range of pages to display
  let startPage = Math.max(1, page - bufferPages);
  let endPage = Math.min(totalPages, page + bufferPages);
  if (endPage - startPage < maxPageToShow - 1) {
    startPage = Math.max(1, endPage - maxPageToShow + 1);
    endPage = Math.min(totalPages, startPage + maxPageToShow - 1);
  }

  return (
    <nav className="small-pagination pt-2">
      <ul>
        <NavigationItemPrevious
          className="small-pagination__arrow small-pagination__prev"
          page={page}
          goToPage={goToPage}
        />
        
        {startPage > 1 && (
          <>
            <NavigationItem key={1} page={page} pageNumber={1} goToPage={goToPage} />
            {startPage > 2 && <li><span className="has-text-gray-400-color">...</span></li>}
          </>
        )}

        {Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index).map(pageNumber => (
          <NavigationItem key={pageNumber} page={page} pageNumber={pageNumber} goToPage={goToPage} />
        ))}

        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && <li className="on-nonmobile"><span className="has-text-gray-400-color">...</span></li>}
            <NavigationItem key={totalPages} page={page} pageNumber={totalPages} goToPage={goToPage} />
          </>
        )}

        <NavigationItemNext
          className="small-pagination__arrow small-pagination__next"
          totalPages={totalPages}
          page={page}
          goToPage={goToPage}
        />
      </ul>
    </nav>
  );
}